import { t } from '../services/configService';
import { stripTags } from './stringUtils';

const getEntityMediaImageAlt = entity =>
  entity.mediaImage.alt &&
  !entity.mediaImage.alt.startsWith('http') &&
  entity.mediaImage.alt.includes('.jpg') === -1
    ? entity.mediaImage.alt
    : undefined;

const getEntityMediaImageTitle = entity =>
  entity.mediaImage.title &&
  !entity.mediaImage.title.startsWith('http') &&
  entity.mediaImage.title.includes('.jpg') === -1
    ? entity.mediaImage.title
    : undefined;

export const getImageEntityAlt = entity =>
  getEntityMediaImageAlt(entity) ||
  stripTags(entity.caption) ||
  getEntityMediaImageTitle(entity);

export const getImageEntityTitle = entity =>
  getEntityMediaImageTitle(entity) ||
  getEntityMediaImageAlt(entity) ||
  stripTags(entity.caption);

const creditPrefixes = {
  'illustrated-by': {
    single: '__ILLUSTRATED_BY__',
    plural: '__ILLUSTRATIONS_BY__'
  },
  'photograph-by': { single: '__PHOTOGRAPH_BY__', plural: '__PHOTOGRAPHS_BY__' }
};

export const getImageCreditPrefix = (prefix, plural = false) => {
  if (plural) {
    return prefix === 'illustrated-by'
      ? t(creditPrefixes[prefix]?.plural)
      : t(creditPrefixes['photograph-by'].plural);
  }
  return prefix === 'illustrated-by'
    ? t(creditPrefixes[prefix]?.single)
    : t(creditPrefixes['photograph-by'].single);
};
